import { Typography, TypographyProps } from "@mui/material"
import React from "react"

export function UnderTitle(props: TypographyProps) {
  return (
    <Typography
      variant="h5"
      color="text.secondary"
      letterSpacing={0.5}
      fontWeight={300}
      sx={{ fontSize: { lg: "1.5rem", md: "1.25rem", xs: "1rem" }, textAlign: "center" }}
      {...props}
    />
  )
}
